var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "beeswarm-container" }, [
    _c("div", { staticClass: "beeswarm-tooltip" }),
    _vm._v(" "),
    _c("svg", {
      staticClass: "beeswarm-plot",
      attrs: { width: _vm.svgWidth, height: _vm.svgHeight }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }